import { SkeletonLayout } from "shared/atoms/SkeletonLayout";

export const ActivityLibrarySkeleton: React.FC = () => {
  return (
    <>
      {[...Array(6)].map((_, index) => (
        <SkeletonLayout
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          layout={{
            type: "row",
            spacing: 1.5,
            padding: 1.5,
            alignItems: "center",
            children: [
              { type: "skeleton", variant: "rounded", width: 16, height: 20, sx: { borderRadius: "4px" } },
              { type: "skeleton", variant: "rounded", width: 52, height: 52 },
              {
                type: "column",
                spacing: 0.5,
                children: [
                  { type: "skeleton", variant: "text", typographyVariant: "subtitle2", width: 160 },
                  { type: "skeleton", variant: "text", typographyVariant: "label", width: 60 },
                ],
              },
              {
                type: "row",
                spacing: 1,
                width: "auto",
                sx: { marginLeft: "auto" },
                children: [
                  { type: "skeleton", variant: "rounded", width: 32, height: 32 },
                  { type: "skeleton", variant: "rounded", width: 32, height: 32 },
                ],
              },
            ],
          }}
        />
      ))}
    </>
  );
};
